module.exports = __webpack_public_path__ + "static/img/linkedin.3f75d89c.svg";